import { render, staticRenderFns } from "./PermissionDataTableRow.vue?vue&type=template&id=e1123434&"
import script from "./PermissionDataTableRow.vue?vue&type=script&lang=js&"
export * from "./PermissionDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports